import React from "react";
import { findAllAcademicConceptEvent } from "../../_events/academic_concept/find.event";
import { alertError } from "../../_utils/alerts";

export const useAcademicConceptAll = () => {

    const [data, setData] = React.useState([]);

    const loadData = () => {
        findAllAcademicConceptEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData();
    }, []);

    return { data, loadData };
}